import { Typography } from "@circle-react-uikit/Typography";

interface AllContentProps {
  description: string;
}

export const AllContent = ({ description }: AllContentProps) => (
  <Typography.BodySm color="text-default">
    <span className="whitespace-pre-wrap">{description}</span>
  </Typography.BodySm>
);
